import React, { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { makeStyles, Box, Typography } from "@material-ui/core";
import Button from "../components/Button";
import { Link } from "react-router-dom";
import Model from "../components/Model";
import output from "./example.json";
import { withRouter, RouteComponentProps } from "../utils/useRouter";
import { useIdentityContext } from "react-netlify-identity";

const Landing: FC<RouteComponentProps> = observer(({ history }) => {
  const classes = styles();
  const {
    param: { type },
    recoverAccount,
  } = useIdentityContext();

  const recover = async () => {
    try {
      await recoverAccount(true);
      history.push("/reset");
    } catch (e) {
      window.alert(
        "Failed to validate token, it may have expired. Please try reset password again."
      );
    }
  };

  useEffect(() => {
    if (type === "recovery") {
      recover();
    }
    /* eslint-disable */
  }, [type]);

  return (
    <Box className={classes.container}>
      <Model geometry={2} output={output} rotate />
      <Box className={classes.textContainer}>
        <Typography className={classes.bold} variant="h5" gutterBottom>
          Welcome to HornWizard 2.0 by Celestion
        </Typography>
      </Box>
      <Link className={classes.link} to="/guide">
        <Button>START</Button>
      </Link>
      <Box className={classes.textContainer}>
        <Typography>Press Start to design your horn.</Typography>
      </Box>
    </Box>
  );
});

const styles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: "30px 0px",
    margin: "0 auto",
    maxWidth: 900,
  },
  textContainer: {
    textAlign: "center",
    margin: "30px 0px",
  },
  heading: {
    fontFamily: typography.fontFamily,
    fontSize: typography.fontSize,
  },
  image: {
    margin: "50px 0",
  },
  italic: {
    fontStyle: "italic",
  },
  bold: {
    fontWeight: "bold",
  },
  link: {
    width: 220,
    textDecoration: "none",
  },
}));

export default withRouter(Landing);
